'use client';
import { useEffect, useState } from 'react';
const INTERVAL = 250;
const getCookie = (name) => {
    if (typeof document === 'undefined')
        return undefined;
    const match = document.cookie.match(new RegExp(`(^|; )${name}=([^;]*)`));
    return match ? decodeURIComponent(match[2]) : undefined;
};
const checkPersonalisationConsent = () => {
    var _a;
    const cookie = getCookie('fides_consent');
    if (cookie) {
        try {
            const cookieObject = JSON.parse(cookie);
            return Boolean((_a = cookieObject.consent) === null || _a === void 0 ? void 0 : _a.functional);
        }
        catch (e) {
            return false;
        }
    }
    return false;
};
export default () => {
    const [isPersonalised, setIsPersonalised] = useState(checkPersonalisationConsent());
    useEffect(() => {
        if (!isPersonalised) {
            const intervalId = setInterval(() => {
                if (checkPersonalisationConsent()) {
                    setIsPersonalised(true);
                    clearInterval(intervalId);
                }
            }, INTERVAL);
            return () => clearInterval(intervalId);
        }
        return undefined;
    }, [isPersonalised]);
    return isPersonalised;
};
